import { render, staticRenderFns } from "./FeePayment.vue?vue&type=template&id=2bad4cc2&scoped=true"
import script from "./FeePayment.vue?vue&type=script&lang=js"
export * from "./FeePayment.vue?vue&type=script&lang=js"
import style0 from "./FeePayment.vue?vue&type=style&index=0&id=2bad4cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bad4cc2",
  null
  
)

export default component.exports